import { useField } from "formik"
import { InputSwitch } from "primereact/inputswitch"

const FormikInputText = ({
  id,
  onChange,
  disabled = false,
  style,
  ...props
}: $TSMigrationFixMe) => {
  const [field] = useField(props)

  return (
    <InputSwitch
      id={id}
      style={style}
      disabled={disabled}
      checked={field.value}
      {...field}
      onChange={onChange || field.onChange}
    />
  )
}

export default FormikInputText
